import React from 'react';

import SmsBundle from 'components/price/SmsBundle.component';
import { useTranslation } from 'providers/GILT.provider';

const TooltipCounter = () => {
  const { t } = useTranslation();

  return (
    <div className="client-info-icon float-none" data-bem="TooltipCounter">
      <span className="tooltip in-auto-top">
        <div className="tooltip-centered">
          {t('clientConnect.tooltipCounter.descriptionPart1')} <SmsBundle>{t('clientConnect.tooltipCounter.descriptionPart2')}</SmsBundle>
        </div>
      </span>
    </div>
  );
};
export default TooltipCounter;
